<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">充提系统</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>充提限制</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="page-content" shadow="never">
      <div class="page-actions" style="display: block">
        <el-input
            placeholder="请输入币种"
            clearable
            v-model="paramsQuery.coinType"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button @click="getCoinList" type="primary">搜 索</el-button>
        <el-button @click="syncCoin" type="primary" style="float: right"
        >同步币种
        </el-button
        >
      </div>
      <el-tabs
          v-model="paramsQuery.areaType"
          @tab-click="getCoinList"
          type="card"
      >
        <el-tab-pane label="主区" name="0"/>
        <el-tab-pane label="创新区" name="1"/>
      </el-tabs>

      <div>
        <el-table
            border
            :header-cell-style="{ background: '#FFF5F4', color: '#EC6D56' }"
            :data="dataList"
            :row-key="() => Math.random()"
        >
          <el-table-column
              prop="coinType"
              label="币种"
              width="100px"
          ></el-table-column>
          <el-table-column
              prop="singleDepositAuditQuota"
              label="单笔充值转人工限制额度"
              show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ getValueText(scope.row.singleDepositAuditQuota) }}
            </template>
          </el-table-column>
          <el-table-column
              prop="todayTotalDepositAuditQuota"
              label="当日累计充值转人工限制额度"
              show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ getValueText(scope.row.todayTotalDepositAuditQuota) }}
            </template>
          </el-table-column>
          <el-table-column
              prop="netLiquidityAuditQuota"
              label="净流通量转人工限制额度"
              show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ getValueText(scope.row.netLiquidityAuditQuota) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="400">
            <template slot-scope="scope">
              <el-button type="primary" @click="whiteListDialog(scope.row)"
              >白名单
              </el-button
              >
              <el-button type="primary" @click="blackListDialog(scope.row)"
              >黑名单
              </el-button
              >
              <el-button type="primary" @click="setLimitDialog(scope.row)"
              >设置限制
              </el-button
              >
              <el-button type="danger" @click="deleteLimit(scope.row)"
              >删除
              </el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="margin-top: 30px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="paramsQuery.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="paramsQuery.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </el-card>

    <el-dialog
        title="设置限制"
        :visible.sync="limitDialogVisible"
        width="800px"
        @close="clearData"
        :close-on-click-modal="false"
    >
      <el-form
          label-width="210px"
          :model="limitData"
          :rules="limitRules"
          ref="limitForm"
      >
        <el-form-item label="单笔充值转人工限制额度" prop="sigleQuota">
          <el-input
              placeholder="请输入单笔充值转人工限制额度"
              v-model="limitData.sigleQuota"
              :disabled="limitData.sigleQuota < 0"
              :min="-1"
              :max="100000000000"
              style="width: 60%"
          ></el-input>
          <el-switch
              active-text="无限制"
              @change="
              limitData.sigleQuota = getToggleValue(limitData.sigleQuota)
            "
              :value="limitData.sigleQuota"
              :active-value="-1"
              style="margin-left: 10px"
          >无限制
          </el-switch
          >
        </el-form-item>
        <el-form-item label="当日累计充值转人工限制额度" prop="totalQuota">
          <div class="div-flex">
            <el-input
              placeholder="当日累计充值转人工限制额度"
              v-model="limitData.todayTotalQuota"
              :disabled="limitData.todayTotalQuota < 0"
              :min="-1"
              :max="100000000000"
              style="width: 60%"
            ></el-input>
            <span style="font-size: 10px; line-height: 20px;">当日累计充值：{{limitData.showTodayTotalDepositTxAmount}}</span>
          </div>
          <el-switch
              active-text="无限制"
              @change="
              limitData.todayTotalQuota = getToggleValue(
                limitData.todayTotalQuota
              )
            "
              :value="limitData.todayTotalQuota"
              :active-value="-1"
              style="margin-left: 340px"
          >无限制
          </el-switch
          >
        </el-form-item>
        <el-form-item label="净流通量转人工限制额度" prop="netLiquidityQuota">
          <div class="div-flex">
            <el-input
              placeholder="净流通量转人工限制额度"
              v-model="limitData.netLiquidityQuota"
              :disabled="limitData.netLiquidityQuota < 0"
              :min="-1"
              :max="100000000000"
              style="width: 60%"
            ></el-input>
            <span style="font-size: 10px; line-height: 20px;">当前净流通量：{{limitData.showNetDepositAmount}}</span>
          </div>
          <el-switch
              active-text="无限制"
              @change="
              limitData.netLiquidityQuota = getToggleValue(
                limitData.netLiquidityQuota
              )
            "
              :value="limitData.netLiquidityQuota"
              :active-value="-1"
              style="margin-left: 340px"
          >无限制
          </el-switch
          >
        </el-form-item>
        <el-form-item label="累计充值总量">
          <div class="div-flex">
            <el-input
              placeholder="累计充值总量"
              v-model="limitData.totalQuota"
              :disabled="limitData.totalQuota < 0"
              :min="-1"
              :max="100000000000"
              style="width: 60%"
            ></el-input>
            <span style="font-size: 10px; line-height: 20px;">当前累计充值总量：{{limitData.showTotalDepositAuditQuota}}</span>
          </div>
          <el-switch
              active-text="无限制"
              @change="
              limitData.totalQuota = getToggleValue(limitData.totalQuota)
            "
              :value="limitData.totalQuota"
              :active-value="-1"
              style="margin-left: 340px"
          >无限制
          </el-switch
          >
        </el-form-item>
        <!-- <el-form-item label="目前累计充值总量">
          <el-input
              placeholder="目前累计充值总量"
              v-model="limitData.showTotalDepositAuditQuota"
              disabled
              style="width: 60%"
          ></el-input>
        </el-form-item> -->
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="limitDialogVisible = false">取 消</el-button>
        <el-button type="danger" :loading="loading" @click="setLimit"
        >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
        :title="blackDialogTitle"
        :visible.sync="blackDialogVisible"
        width="1000px"
        @close="clearDataOne"
        :close-on-click-modal="false"
    >
      <el-form
          label-width="100px"
          :model="blackData"
          :rules="blackRules"
          ref="blackForm"
      >
        <el-form-item label="用户UID" prop="uid">
          <el-input
              placeholder="请输入黑名单用户UID"
              v-model="blackData.uid"
              style="width: 60%"
          ></el-input>
        </el-form-item>
        <el-form-item label="限制功能" prop="isAudit">
          <el-radio-group v-model="blackData.isAudit">
            <el-radio :label="true" style="display: block; margin-top: 11px"
            >充值转人工审核
            </el-radio
            >
            <el-row :gutter="50">
              <el-col :span="22">
                <el-radio
                    :label="false"
                    style="display: block; margin-left: 0; margin-top: 11px"
                >当日累计充值>=
                  <el-form-item prop="limitQuota" style="display: inline-block">
                    <el-input-number
                        placeholder="请输入限制额度"
                        v-model="blackData.limitQuota"
                        :disabled="blackData.isAudit"
                        :min="0"
                        :max="100000000000"
                        :rules="[
                        {
                          message: '请输入限制额度',
                          required: !blackData.isAudit,
                        },
                      ]"
                        style="width: 300px"
                    ></el-input-number>
                  </el-form-item>
                  转人工审核
                </el-radio>
              </el-col>
              <el-col :span="2">
                <el-button
                    type="primary"
                    @click="addBlackList"
                    style="margin-top: 11px"
                >
                  加入黑名单
                </el-button>
              </el-col>
            </el-row>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div
          style="height: 1px; background-color: #f2f2f2; margin-bottom: 10px"
      ></div>

      <div class="page-actions" style="display: block">
        <el-input
            placeholder="输入用户ID搜索"
            clearable
            v-model="blackParamsQuery.uid"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button @click="getBlackList" type="primary">搜 索</el-button>
      </div>

      <div>
        <el-table
            border
            :header-cell-style="{ background: '#FFF5F4', color: '#EC6D56' }"
            :data="blackList"
            :row-key="() => Math.random()"
        >
          <el-table-column prop="userId" label="用户ID"></el-table-column>
          <el-table-column label="限制功能">
            <template slot-scope="scope">
              <span v-if="scope.row.transferToManualAudit">充值转人工审核</span>
              <span v-if="!scope.row.transferToManualAudit"
              >当日累计充值>={{ scope.row.limitQuota }}转人工</span
              >
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button type="danger" @click="removeBlackList(scope.row)"
              >移除黑名单
              </el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="margin-top: 30px"
            @size-change="handleBlackSizeChange"
            @current-change="handleBlackCurrentChange"
            :current-page="blackParamsQuery.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="blackParamsQuery.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="blackTotal"
        >
        </el-pagination>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="blackDialogVisible = false"
        >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
        :title="whiteDialogTitle"
        :visible.sync="whiteDialogVisible"
        width="1000px"
        @close="clearDataTwo"
        :close-on-click-modal="false"
    >
      <el-form
          label-width="100px"
          :model="whiteData"
          :rules="whiteRules"
          ref="whiteForm"
      >
        <el-form-item label="用户UID" prop="uid">
          <el-input
              placeholder="请输入黑名单用户UID"
              v-model="whiteData.uid"
              style="width: 60%"
          ></el-input>
        </el-form-item>
        <el-form-item label="不受限功能">
          <el-checkbox v-model="whiteData.singleDepositAudit"
          >单笔充值转人工
          </el-checkbox
          >
          <el-checkbox v-model="whiteData.totalDepositAudit"
          >累计充值转人工
          </el-checkbox
          >
          <el-checkbox v-model="whiteData.whiteListDeposit"
          >白名单充值
          </el-checkbox
          >
          <el-row :gutter="50">
            <el-col :span="19">
              <el-checkbox v-model="whiteData.whiteListWithdraw"
              >白名单提现
              </el-checkbox
              >
            </el-col>
            <el-col :span="2">
              <el-button
                  type="primary"
                  @click="addWhiteList"
                  style="margin-top: 11px"
              >
                加入白名单
              </el-button>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <div
          style="height: 1px; background-color: #f2f2f2; margin-bottom: 10px"
      ></div>

      <div class="page-actions" style="display: block">
        <el-input
            placeholder="输入用户ID搜索"
            clearable
            v-model="blackParamsQuery.uid"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button @click="getWhiteList" type="primary">搜 索</el-button>
      </div>

      <div>
        <el-table
            border
            :header-cell-style="{ background: '#FFF5F4', color: '#EC6D56' }"
            :data="whiteList"
            :row-key="() => Math.random()"
        >
          <el-table-column prop="userId" label="用户ID"></el-table-column>
          <el-table-column label="不受限功能">
            <template slot-scope="scope">
              <span v-if="scope.row.singleDepositAudit">单笔充值转人工;</span>
              <span v-if="scope.row.totalDepositAudit">累计充值转人工;</span>
              <span v-if="scope.row.whiteListDeposit">白名单充值;</span>
              <span v-if="scope.row.whiteListWithdraw">白名单提现</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button type="danger" @click="removeWhiteList(scope.row)"
              >移除白名单
              </el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="margin-top: 30px"
            @size-change="handleWhiteSizeChange"
            @current-change="handleWhiteCurrentChange"
            :current-page="blackParamsQuery.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="blackParamsQuery.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="whiteTotal"
        >
        </el-pagination>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="whiteDialogVisible = false"
        >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import "./store";
import api from "./api";

export default {
  name: "DepositLimit",
  data() {
    return {
      dataList: [],
      total: 0,
      paramsQuery: {areaType: "0", coinType: "", page: 1, size: 10},
      limitDialogVisible: false,
      limitData: {
        coinType: "",
        sigleQuota: "",
        totalQuota: "",
        netLiquidityQuota: "",
        todayTotalQuota: "",
        showTotalDepositAuditQuota: "",
      },
      limitRules: {
        coinType: [{required: true, message: "币种不能为空"}],
        sigleQuota: [
          {required: true, message: "单笔充值转人工限制额度不能为空"},
        ],
        totalQuota: [
          {required: true, message: "当日累计充值转人工限制额度不能为空"},
        ],
        netLiquidityQuota: [
          {required: true, message: "净流通量转人工限制额度不能为空"},
        ],
      },
      loading: false,
      blackDialogTitle: "",
      blackDialogVisible: false,
      blackData: {coinType: "", uid: "", isAudit: true, limitQuota: ""},
      blackRules: {
        coinType: [{required: true, message: "币种不能为空"}],
        uid: [{required: true, message: "请输入用户UID"}],
        isAudit: [{required: true, message: "请选择限制功能"}],
        limitQuota: [{required: true, message: "请输入限制额度"}],
      },
      blackParamsQuery: {coinType: "", uid: "", page: 1, size: 10},
      blackList: [],
      blackTotal: 0,
      whiteDialogTitle: "",
      whiteDialogVisible: false,
      whiteData: {
        coinType: "",
        uid: "",
        singleDepositAudit: true,
        totalDepositAudit: true,
        whiteListDeposit: true,
        whiteListWithdraw: true,
      },
      whiteRules: {
        coinType: [{required: true, message: "币种不能为空"}],
        uid: [{required: true, message: "请输入用户UID"}],
      },
      whiteList: [],
      whiteTotal: 0,
    };
  },
  methods: {
    getCoinList() {
      api.getCoinList(this.paramsQuery).then(({data}) => {
        if (data) {
          this.dataList = data.list;
          this.total = data.totalCount;
        } else {
          this.dataList = [];
          this.total = 0;
        }
      });
    },
    getBlackList() {
      api.getBlackList(this.blackParamsQuery).then(({data}) => {
        if (data) {
          this.blackList = data.list;
          this.blackTotal = data.totalCount;
        } else {
          this.blackList = [];
          this.blackTotal = 0;
        }
      });
    },
    getWhiteList() {
      api.getWhiteList(this.blackParamsQuery).then(({data}) => {
        if (data) {
          this.whiteList = data.list;
          this.whiteTotal = data.totalCount;
        } else {
          this.whiteList = [];
          this.whiteTotal = 0;
        }
      });
    },
    syncCoin() {
      api.syncCoin().then(({data}) => {
        this.$message.success("同步成功!");
      });
    },
    handleSizeChange(val) {
      this.paramsQuery.size = val;
      this.getCoinList();
    },
    handleCurrentChange(val) {
      this.paramsQuery.page = val;
      this.getCoinList();
    },
    handleBlackSizeChange(val) {
      this.blackParamsQuery.size = val;
      this.getBlackList();
    },
    handleBlackCurrentChange(val) {
      this.blackParamsQuery.page = val;
      this.getBlackList();
    },
    handleWhiteSizeChange(val) {
      this.blackParamsQuery.size = val;
      this.getWhiteList();
    },
    handleWhiteCurrentChange(val) {
      this.blackParamsQuery.page = val;
      this.getWhiteList();
    },
    whiteListDialog(row) {
      this.whiteDialogTitle = row.coinType.toUpperCase() + "充提限制白名单";
      this.blackParamsQuery = {
        coinType: row.coinType,
        uid: "",
        page: 1,
        size: 10,
      };
      this.whiteData = {
        coinType: row.coinType,
        uid: "",
        singleDepositAudit: true,
        totalDepositAudit: true,
        whiteListDeposit: true,
        whiteListWithdraw: true,
      };
      this.getWhiteList();
      this.whiteDialogVisible = true;
    },
    blackListDialog(row) {
      this.blackDialogTitle = row.coinType.toUpperCase() + "充提限制黑名单";
      this.blackParamsQuery = {
        coinType: row.coinType,
        uid: "",
        page: 1,
        size: 10,
      };
      this.blackData = {
        coinType: row.coinType,
        uid: "",
        isAudit: true,
        limitQuota: "",
      };
      this.getBlackList();
      this.blackDialogVisible = true;
    },
    addBlackList() {
      this.$refs["blackForm"].validate((valid) => {
        if (valid) {
          api.addBlackList(this.blackData).then(({data}) => {
            this.$message.success("添加成功！");
            this.getBlackList();
          });
        }
      });
    },
    addWhiteList() {
      this.$refs["whiteForm"].validate((valid) => {
        if (valid) {
          api.addWhiteList(this.whiteData).then(({data}) => {
            this.$message.success("添加成功！");
            this.getWhiteList();
          });
        }
      });
    },
    setLimitDialog(row) {
      api.findByCoin({coinType: row.coinType}).then(({data}) => {
        this.limitData = {
          coinType: data.coinType,
          sigleQuota: this.getValueFormat(data.singleDepositAuditQuota),
          todayTotalQuota: row.todayTotalDepositAuditQuota,
          netLiquidityQuota: this.getValueFormat(data.netLiquidityAuditQuota),
          totalQuota: this.getValueFormat(data.totalDepositAuditQuota),
          showTotalDepositAuditQuota: data.showTotalDepositAuditQuota,
          showTodayTotalDepositTxAmount:data.showTodayTotalDepositTxAmount,
          showNetDepositAmount:data.showNetDepositAmount
        };
        this.limitDialogVisible = true;
      });
    },
    setLimit() {
      if(!this.limitData.todayTotalQuota) {
         this.$notify.error({
          title: '错误',
          message: '请填写完整'
        });
        return false;
      }
      this.$refs["limitForm"].validate((valid) => {
        if (valid) {
          api.setLimit(this.limitData).then(({data}) => {
            this.$message.success("设置成功！");
            this.limitDialogVisible = false;
            this.getCoinList();
          });
        }
      });
    },
    removeBlackList(row) {
      this.$confirm("确认从黑名单移除吗？", "提示", {
        type: "warning",
      })
          .then(() => {
            api
                .deleteBlackList({coinType: row.coinType, uids: row.userId})
                .then(({data}) => {
                  this.$message.success("移除成功！");
                  this.getBlackList();
                });
          })
          .catch(() => {
          });
    },
    removeWhiteList(row) {
      this.$confirm("确认从白名单移除吗？", "提示", {
        type: "warning",
      })
          .then(() => {
            api
                .deleteWhiteList({coinType: row.coinType, uids: row.userId})
                .then(({data}) => {
                  this.$message.success("移除成功！");
                  this.getWhiteList();
                });
          })
          .catch(() => {
          });
    },
    deleteLimit(row) {
      this.$confirm("确认删除吗？", "提示", {
        type: "warning",
      })
          .then(() => {
            api.deleteLimit({coinType: row.coinType}).then(({data}) => {
              this.$message.success("移除成功！");
              this.getCoinList();
            });
          })
          .catch(() => {
          });
    },
    clearData() {
      this.$refs["limitForm"].resetFields();
      this.loading = false;
    },
    clearDataOne() {
      this.$refs["blackForm"].resetFields();
      this.blackParamsQuery = {coinType: "", uid: "", page: 1, size: 10};
    },
    clearDataTwo() {
      this.$refs["whiteForm"].resetFields();
      this.blackParamsQuery = {coinType: "", uid: "", page: 1, size: 10};
      this.blackParamsQuery = {coinType: "", uid: "", page: 1, size: 10};
    },
    getValueText(value) {
      if (value === null || value < 0) return "";
      return value;
    },
    getValueFormat(value) {
      if (value === null || value < 0) return -1;
      return value;
    },
    getToggleValue(value) {
      if (value >= 0) return -1;
      else return 0;
    },
  },
  created() {
    this.getCoinList();
  },
};
</script>

<style lang="less" scoped>
.div-flex {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: absolute;
}
</style>
